<template>
  <div>
    <ShareDetailToolbar/>
    <v-tabs :color="ui.bkgdColor" :slider-color="ui.sliderColor" v-model="tab">
      <v-tab href="#tab-1">
        <v-tabs-slider/>
        <div :class="ui.textColorSecondary">
          Info
        </div>
      </v-tab>
      <v-tab href="#tab-2">
        <div :class="ui.textColorSecondary">
          Detail
        </div>
      </v-tab>
      <v-tab href="#tab-3">
        <div :class="ui.textColorSecondary">
          Links
        </div>
      </v-tab>
      <v-tab href="#tab-4">
        <div :class="ui.textColorSecondary">
          Transport
        </div>
      </v-tab>
      <v-tab href="#tab-5">
        <div :class="ui.textColorSecondary">
          Storage
        </div>
      </v-tab>
      <v-tab href="#tab-6">
        <div :class="ui.textColorSecondary">
          Order
        </div>
      </v-tab>
      <v-tab href="#tab-7">
        <div :class="ui.textColorSecondary">
          Invent
        </div>
      </v-tab>
      <v-tab href="#tab-8">
        <div :class="ui.textColorSecondary">
          Relps.
        </div>
      </v-tab>
      <v-tab href="#tab-9">
        <div class="body wplblue0--text">
          Attach
        </div>
      </v-tab>
      <v-tab href="#tab-10">
        <div class="body wplblue0--text">
          Revs.
        </div>
      </v-tab>
      <!-- Basic / Info -->
      <v-tab-item :key="1" :value="'tab-1'">
        <ShareDetailInfo/>
      </v-tab-item>
      <!-- Part Detail -->
      <v-tab-item :key="2" :value="'tab-2'">
        <MaterialDetailDescribe v-if="this.tab === 'tab-2'"/>
      </v-tab-item>
      <!-- Part Transport  -->
      <v-tab-item :key="3" :value="'tab-3'">
        <ShareDetailSite v-if="this.tab === 'tab-3'"/>
      </v-tab-item>
      <!-- Part Transport  -->
      <v-tab-item :key="4" :value="'tab-4'">
        <MaterialDetailTransport v-if="this.tab === 'tab-4'"/>
      </v-tab-item>
      <!-- Storage  -->
      <v-tab-item :key="5" :value="'tab-5'">
        <MaterialDetailStorage v-if="this.tab === 'tab-5'"/>
      </v-tab-item>
      <!-- Part -->
      <v-tab-item :key="6" :value="'tab-6'">
        <MaterialDetailOrder v-if="this.tab === 'tab-6'"/>
      </v-tab-item>
      <!-- Part -->
      <v-tab-item :key="7" :value="'tab-7'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-7'">
          <Inventory/>
        </v-container>
      </v-tab-item>
      <!-- Relationships -->
      <v-tab-item :key="8" :value="'tab-8'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-8'">
          <RelationshipRegister/>
        </v-container>
      </v-tab-item>
      <!-- Attachments -->
      <v-tab-item :key="9" :value="'tab-9'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-9'">
          <Attachments/>
        </v-container>
      </v-tab-item>
      <!-- Revisions -->
      <v-tab-item :key="10" :value="'tab-10'">
        <RevisionDash v-if="this.tab === 'tab-10'"/>
      </v-tab-item>
    </v-tabs>
    <DetailChange/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import Actions from "@/support/actions/components/Actions";
import ShareDetailInfo from "@/support/share/components/ShareDetailInfo";
import MaterialDetailDescribe from "@/logistics/material/components/MaterialDetailDescribe";
import MaterialDetailTransport from "@/logistics/material/components/MaterialDetailTransport";
import MaterialDetailStorage from "@/logistics/material/components/MaterialDetailStorage";
import MaterialDetailOrder from "@/logistics/material/components/MaterialDetailOrder";
import Inventory from "@/logistics/inventory/components/Inventory";
import RelationshipRegister from "@/data/list/components/RelationshipRegister";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import RevisionDash from "@/document/revisions/components/RevisionDash";
import DetailChange from "@/support/detail/components/DetailChange";
import Attachments from "@/document/attachments/components/Attachments";
import ShareDetailToolbar from "@/support/share/components/ShareDetailToolbar";
import ShareDetailSite from "@/support/share/components/ShareDetailSite";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import documentFunctions from "@/data/functions/mixins/documentFunctions.js";

export default {
  components: {
    Attachments,
    DetailChange,
    ShareDetailInfo,
    ShareDetailSite,
    MaterialDetailDescribe,
    MaterialDetailTransport,
    MaterialDetailStorage,
    RelationshipRegister,
    MaterialDetailOrder,
    Inventory,
    RevisionDash,
    ShareDetailToolbar
  },
  // eslint-disable-next-line
  mixins: [
    apptheme,
    storeFunctions,
    displayFunctions,
    documentFunctions
  ],
  data() {
    return {
      valid: true,
      value: "",
      tab: ""
    };
  },
  beforeDestroy() {
    this.$store.dispatch("changeDocumentRevMod", null);
    // this.resetStoreDetail();
    // this.setDetailBasicSave(true);
  },
  // eslint-disable-next-line
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getDetail",
      "getDetailBasic",
      "getAsset",
      "getDataSavePendingIndication"
    ]),
    dataSavePendingColor() {
      // eslint-disable-next-line
      if (this.getDataSavePendingIndication === true) {
        return "wplorange0";
      } else {
        return this.ui.bkgdColor;
      }
    }
  }
};
</script>
